module.exports = __webpack_public_path__ + "static/Maruthi-Suzuki-Wagon-R-0de175bafa1506646f2ee981920107ee.png";